module.exports = __webpack_public_path__ + "img/mediaMinus.06b65e00.svg";